import { environmentBuilder } from '@pascal/pascal-core';
import { gameName } from '../../enums/gameConfigsAndUrls';

const { httpUrl: url } = environmentBuilder(gameName);

export const addFavoriteBetUrl = () => `${url}/api/v1/Users/favouriteBet`;

export const getFavoriteBetsByGameTypeId = (gameTypeId) => `${url}/api/v1/Users/favouriteBets/${gameTypeId}`;

export const deleteFavoriteBetsUrl = (favouriteBetId) => `${url}/api/v1/Users/${favouriteBetId}`;

export const editFavoriteBet = (id) => `${url}/api/v1/Users/favouriteBetId?favouriteBetId=${id}`;

export const getFirstStep = ({skip, take}) => `${url}/api/v1/Bets/betsByDay?Skip=${skip}&Take=${take}`;

export const getSecondStep = ({startDay, endDay}) => `${url}/api/v1/Bets?StartDate=${startDay}&EndDate=${endDay}`;

export const getThirdStep = ({betId}) => `${url}/api/v1/Bets?BetId=${betId}`;
